import React from 'react'
import { observer } from 'mobx-react'
import useNavigationManager from '../hooks/use-navigation-manager'

function CurrentStep ({text = null, divider = '/'}) {
  const manager = useNavigationManager()

  return (
    <div className={'current-step'}>
      {text}<span className={'current-step__current'}>{manager.currentStep + 1}</span>{divider}<span
      className={'current-step__total'}>{manager.steps.length}</span>
    </div>
  )
}

export default observer(CurrentStep)